import React, { useEffect } from 'react'
import styles from './Datepicker.module.css'
import './datepicker-custom.css'
import DatePicker, { registerLocale } from "react-datepicker";
import th from "date-fns/locale/th"; // Import ภาษาไทย
import { format, subYears, addYears } from "date-fns";
import { FaCalendarAlt, FaTimes } from "react-icons/fa"; 


// ลงทะเบียน locale ภาษาไทย
registerLocale("th", th);

function Datepicker({disabled, label, value, setValue, className, title}) {
    const convertToThaiFormat = (date) => { 
        if (!date) return "";
        const thaiYear = date.getFullYear() + 543; // แปลงปี ค.ศ. เป็น พ.ศ.
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // เดือนเริ่มจาก 0 จึงต้อง +1
        return `${day}/${month}/${thaiYear}`;
    };

    const clearCalendar = () => {
        setValue();
    };

    // Custom input component
    const CustomInput = React.forwardRef(({ value, onClick, disabled }, ref) => (
      <div
        className="flex border-[1px] border-[#eee] rounded-[5px]"
        style={{
          height: "40px",
          border: "1px solid #A2B5BC",
          backgroundColor: disabled ? "#f7f7f7" : "#ffffff",
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.6 : 1,
        }}
      >
        <FaCalendarAlt
          className={styles.calendarIcon} 
          color="#747081"
        />
        <input
          type="text"
          className={styles.input}
          onClick={onClick}
          ref={ref}
          value={value ? convertToThaiFormat(new Date(value)) : ""}
          placeholder="เลือกวันที่"
          readOnly
          disabled={disabled}
        />

        {!disabled && (
          <FaTimes
            className={styles.clearIcon}
            onClick={clearCalendar}
          />
        )}
      </div>
    ));
    
    

    const handleChange = (date) => {

        // ตรวจสอบว่าค่า date ไม่ใช่ undefined
        if (date) {
            const formattedDate = format(date, "dd/MM/yyyy");
            if(formattedDate && formattedDate !== undefined){
                // console.log(props.setValue)
                setValue(date)
            }
            // console.log("เลือกวันที่:", formattedDate);
        } else {
          console.error("Date is undefined!");
        }
    };
  
    useEffect(() => {
        // Log ใน useEffect เพื่อดูการเปลี่ยนแปลง
        // console.log("selectedDate updated:", value);
    }, [value]);

    const toDate = (val) => {
      if (!val) return null;
      if (val instanceof Date) return val;
      const d = new Date(val);
      return isNaN(d.getTime()) ? null : d;
    };

    return (
      <div className='flex flex-col'>
        {label && (
          <label
            className={title === "publicity" ? `${className}` : `${styles.label}`}
          >
            {label}
          </label>
        )}
        <DatePicker
          // className="cursor-pointer"
          selected={toDate(value)}
          onChange={handleChange}
          disabled={disabled}
          locale="th" // ใช้ locale ภาษาไทย
          placeholderText={`เลือก${label}`}
          dropdownMode="select" // เเสดง dropdown
          customInput={<CustomInput />}
          //dateFormat="dd/MM/yyyy" // กำหนดรูปแบบวันที่
          // showMonthDropdown // แสดง dropdown สำหรับเลือกเดือน
          // showYearDropdown // แสดง dropdown สำหรับเลือกปี
          renderCustomHeader={({
            date,
            changeYear,
            changeMonth,
            decreaseMonth,
            increaseMonth,
            prevMonthButtonDisabled,
            nextMonthButtonDisabled,
          }) => {
            let dateFormat = date;
            if (typeof date === "string") {
              dateFormat = new Date(date);
            }
            const year = dateFormat.getFullYear();
            const month = dateFormat.getMonth();

            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                  justifyContent: "space-around",
                }}
              >
                <button
                  onClick={decreaseMonth}
                  disabled={prevMonthButtonDisabled}
                >
                  {"<"}
                </button>
                <select
                  value={month}
                  onChange={(e) => changeMonth(Number(e.target.value))}
                >
                  {Array.from({ length: 12 }).map((_, i) => (
                    <option key={i} value={i}>
                      {format(new Date(2000, i, 1), "MMMM", { locale: th })}
                    </option>
                  ))}
                </select>
                <select
                  value={year}
                  onChange={(e) => changeYear(Number(e.target.value))}
                >
                  {Array.from({ length: 150 }).map((_, i) => {
                    const y = subYears(new Date(), i).getFullYear();
                    return (
                      <option key={y} value={y}>
                        {y + 543}
                      </option>
                    );
                  })}
                </select>
                <button
                  onClick={increaseMonth}
                  disabled={nextMonthButtonDisabled}
                >
                  {">"}
                </button>
              </div>
            );
          }}
        />
      </div>
    );
}

export default Datepicker